// /opt/ptg01-v1/front-extranet/components/CommandPaletteHost.tsx
// Sprint 2026-05-17 (Sprint 3b) — Owner du state open/close pour la palette ⌘K.
//
// Pourquoi un wrapper : éviter de polluer DashboardLayout avec du useState + listener
// keyboard. Le composant écoute window 'keydown', filtre ⌘K (mac) ou Ctrl+K (win/linux)
// et toggle le state. Le `preventDefault()` est essentiel — Safari macOS bind ⌘K à
// "focus address bar" par défaut.
'use client';

import React, { useEffect, useState } from 'react';
import CommandPalette from './CommandPalette';

/** Event custom — n'importe quel bouton (TopBar mobile, FAB, etc.) peut le dispatcher pour ouvrir la palette. */
export const COMMAND_PALETTE_OPEN_EVENT = 'nx-command-palette-open';
export function openCommandPalette() {
    if (typeof window !== 'undefined') window.dispatchEvent(new Event(COMMAND_PALETTE_OPEN_EVENT));
}

export default function CommandPaletteHost() {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onKey = (e: KeyboardEvent) => {
            // ⌘K (mac) ou Ctrl+K (autres)
            if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
                e.preventDefault();
                setOpen(o => !o);
            }
        };
        const onCustomOpen = () => setOpen(true);
        window.addEventListener('keydown', onKey);
        window.addEventListener(COMMAND_PALETTE_OPEN_EVENT, onCustomOpen);
        return () => {
            window.removeEventListener('keydown', onKey);
            window.removeEventListener(COMMAND_PALETTE_OPEN_EVENT, onCustomOpen);
        };
    }, []);

    return <CommandPalette open={open} onClose={() => setOpen(false)} />;
}
